import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  uploadFileDataV1,
  updateBulkUploadFileUploader,
  updateBulkUploadFormData,
  updateBulkScreen,
  updateFileName,
  resetBulkUploadData,
  startBulkProcess,
  updateBulkProcessing,
  updateBulkScreenMsg,
  updateSkipFileCheck,
  updateBulkScreenError,
} from "../../actions/bulkProcessAction";
import ScanError from "./ScanError.js";
import { Label } from "reactstrap";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import ProfileService from "../../services/profileService";
import TemplateGuideModal from "../Modals/TemplateGuideModal";
import { makeRequestAuth } from "../../utils/globals";
import {
  REWARD_TYPES,
  BULK_UPLOAD_SAMPLE_FILE_DATA,
  XOXOLINK_BULK_SAMPLE_ONLY_EMAIL,
  XOXOLINK_BULK_SAMPLE_ONLY_MESSAGE,
  XOXOLINK_BULK_SAMPLE_BOTH_EMAIL_MESSAGE,
  BULK_COLUMN_DEF,
  BATCH_STATUS_POLLING,
} from "../../constants/bulkProcessConstant";
import DownloadSampleProduct from "../../modules/ClientDashboard/DownloadSampleProduct";
import KybErrorModal from "../Modals/KybErrorModal";
import {
  Button,
  Modal,
  Icon,
  Banner,
  Loaders,
  CircularLoader,
} from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import styled from "styled-components";
import { app_path } from "config";
import { StyledBorderHorizontal } from "../../modules/Accounts/PlatformPreferences/Component/styled";
import { XoxodayLongLogo } from "../Icons";
import GrandTotalToolTip from "../../modules/XoxoLink/Recipient/GrandTotalToolTip";
import BrandApprovalWarningBanner from "../BrandApprovalWarningBanner";
import { updateUserBalance } from "../../actions/userAction";
import { getUserBalance } from "../../global/getUserBalance";


const StyledFileDiv = styled.div`
  background: ${(props) => props.theme.palette.light.c100};
  border-radius: 8px;
  padding: 24px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 478px;
`;

const StyledBorderedDiv = styled.div`
  border: 1px dashed var(--Dark-c000, #bac9de);
  border: 1px dashed var(--Dark-c000, color(display-p3 0.749 0.7882 0.8549));
`;

const DEFAULT_BULK_UPLOAD_DATA = {
  reward_type: REWARD_TYPES.XOXO_CODE,
  skip_filename_check: 0,
  attachments: "",
};

const DEFAULT_SMS_TEXT = "Congratulations! You have received a Xoxo Code.";
class BulkProcess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateModal: false,
      removeFile: false,

      subHeader: "", // sub header of success modal
      preview: false,
      activeTab: "1",
      addAmount: 0,
      actionModalMessage: "",
      confirmSendBtnText: "Send",
      showPaymentModal: false,
      showmessageModal: false, // state to manage sucess message
      successMessage: "", // stores success message
      selectedDate: "",
      smsTextCount: DEFAULT_SMS_TEXT.length,
      // bulk related state
      isBulkUpload: false, //bulk upload switch
      fileEditWarning: false,
      rewardUseCase: "",
      openKybErrorModal: false,
      bulkToSingle: false,
      progress: 10,
      voucherProducts: [],
      bulkProductsLoading: false,
    };
    this.timer = null;
    this.fileInput = React.createRef();
  }

  /* 
        ==================================================================================
        ==================================================================================
        Lifecycle Method
        ==================================================================================
        ==================================================================================
    */

  componentDidMount() {
    if (this.props.reward_type == 3) {
      const startdate = moment();
      const new_date = moment(startdate, "DD-MM-YYYY").add(365, "days");
      this.setState({ selectedDate: new_date.format("DD-MM-YYYY") });
      //  const smsText = "Congratulations! You have been awarded";
      // this.setState({ smsText });
      this.setState(
        {
          emailSubject: this.props.emailSubject,
          emailHeading: this.props.emailHeading,
          emailTitle: this.props.emailTitle,
          emailLogo: this.props.company_primary_logo,
          selectedTemplate: this.props.selectedTemplate,
          buttonText: this.props.buttonText,
          smsLink: this.props.smsLink,
          smsText: this.props.smsText,
          smsTextCount: this.props.smsTextCount,
        },
        () => {
          this.setInitialData();
        }
      );
    } else {
      this.setInitialData();
    }
  }

  componentWillUnmount() {
    this.props.resetBulkUploadData();
    clearInterval(this.timer);
    this.setState({ progress: 10 });
  }

  componentDidUpdate(prevProps) {
    const {
      bulkUploadData: {
        processing = false,
        uploadFileMsg = "",
        activeScreen = 0,
        batchProcessData: {
          currentAmount = 0,
          currentCount = 0,
          scheduledCount = 0,
          total_rows = 0,
        },
      } = {},
    } = this.props;
    const { bulkUploadData } = prevProps;
    if (bulkUploadData.processing != processing && processing == 5) {
      this.handleBulkSucces();
    }
    if (
      !prevProps.bulkUploadData.uploadFileMsg &&
      prevProps.bulkUploadData.uploadFileMsg !== uploadFileMsg
    ) {
      let ele = document.getElementById("scroll_up");
      if (ele) {
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start",
        });
      }
    } else if (activeScreen === 1) {
      let element = document.getElementById("error_message");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "end",
        });
      }
    }
    // if (!prevProps.startBulk && this.props.startBulk === true)
    //   this.startBulkProcess();

    // if (
    //   prevProps.selectedDelivery != this.props.selectedDelivery &&
    //   this.props.selectedDelivery != 3
    // ) {
    //   this.setState({ activePreviewTab: "" + this.props.selectedDelivery });
    // }
    // if (
    //   this.props.reward_type == 3 &&
    //   this.props.selectedDelivery != 3 &&
    //   this.props.selectedDelivery != this.state.activePreviewTab
    // ) {
    //   this.setState({ activePreviewTab: "" + this.props.selectedDelivery });
    // }
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.verifyFile) {
      this.timer = setInterval(() => {
        this.setState(({ progress }) => {
          return progress >= 90
            ? { progress: 90 }
            : { progress: progress + 10 };
        });
      }, 200);
      this.uploadBulkFileData();
      this.props.setVerifyFile(false);
    }

    if (nextProps.startBulk) {
      this.startBulkProcess();
      this.props.setStartBulk(false);
    }
    return true;
  }

  setConfirModalMessage = () => {
    const { reward_type } = this.props;
    const {
      accountReducer: {
        userBalance: { currencyCode = "INR" },
      },
      bulkUploadData: {
        batchProcessData: {
          currentAmount = 0,
          currentCount = 0,
          scheduledCount = 0,
          total_rows = 0,
          scheduledAmount = 0,
        },
      } = {},
    } = this.props;

    const sendBtnText = [
      "Xoxo Points ",
      "Reward Codes ",
      "Xoxo Link",
      "Vouchers",
    ];
    let actionModalMessage = "";
    const isProcurementApprovalRequired =
      this.props.accountReducer?.platformSettings
        ?.isProcurementApprovalRequired;
    const initialText = isProcurementApprovalRequired
      ? "You are procuring "
      : "You are sending ";
    if (scheduledCount > 0 && currentCount > 0) {
      actionModalMessage =
        initialText +
        sendBtnText[reward_type - 1] +
        " to " +
        currentCount +
        (currentCount > 1 ? " recipients " : " recipient ") +
        "and schedule for " +
        scheduledCount +
        (scheduledCount > 1 ? " recipients" : " recipient") +
        " worth " +
        currencyCode +
        " " +
        (scheduledAmount + currentAmount) +
        " through CSV file upload. Do you want to proceed?";
    } else if (currentCount > 0 && scheduledCount <= 0 && reward_type !== 4) {
      actionModalMessage =
        initialText +
        sendBtnText[reward_type - 1] +
        " to " +
        currentCount +
        (currentCount > 1 ? " recipients " : " recipient ") +
        " worth " +
        currencyCode +
        " " +
        currentAmount +
        " through CSV file upload. Do you want to proceed? ";
    } else if (currentCount <= 0 && scheduledCount > 0) {
      actionModalMessage =
        "You are scheduling " +
        sendBtnText[reward_type - 1] +
        " for " +
        +scheduledCount +
        (scheduledCount > 1 ? " recipients" : " recipient") +
        " through CSV file upload. Do you want to proceed?";
    } else if (reward_type == 3) {
      actionModalMessage =
        initialText +
        "" +
        sendBtnText[reward_type - 1] +
        "" +
        " to " +
        "" +
        total_rows +
        (total_rows > 1 ? " recipients" : " recipient") +
        "" +
        " through CSV file upload. The links sent will be redeemable only by the recipients mentioned. Do you want to proceed?";
    } else if (currentCount > 0 && scheduledCount <= 0 && reward_type === 4) {
      actionModalMessage =
        "Are you sure you want to send Brand " +
        (currentCount > 1 ? "Vouchers" : "Voucher") +
        " to " +
        currentCount +
        (currentCount > 1 ? " recipients" : " recipient") +
        " through CSV file upload. Do you want to proceed? ";
    } else {
      actionModalMessage =
        initialText +
        sendBtnText[reward_type - 1] +
        " to " +
        (scheduledCount + currentCount) +
        (scheduledCount + currentCount > 1 ? " recipients" : " recipient") +
        " through CSV file upload. Do you want to proceed?";
    }

    this.setState({ confirmSendModal: true, actionModalMessage });
  };
  exportCxmlInfo = () => {
    const blob = new Blob([this.props.bulkUploadData.cxmlData], {
      type: "application/xml",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = "recipients.xml";
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener";
    window.open(url, "_blank");
    // link.click();
  };

  setInitialData = () => {
    const { reward_type, uploadFileData } = this.props;

    let rewardUseCase = "";
    switch (reward_type) {
      case 1:
        rewardUseCase = "points-distribution";
        break;
      case 2:
        rewardUseCase = "code-distribution";
        break;
      case 3:
        rewardUseCase = "link-distribution";
        break;
      case 4:
        rewardUseCase = "plum-pro-distribution";
        break;
      default:
        rewardUseCase = "";
        break;
    }

    uploadFileData["reward_type"] = reward_type;
    this.props.setUploadFileData(uploadFileData);
    this.setState({ rewardUseCase });
    if (reward_type == 1) {
      let smsText = "Congratulations!";
      this.setState({ smsText });
    }

    if (reward_type == 4) {
      let smsText = "Congratulations! You have been awarded";
      this.setState({ smsText });
    }
    // setEmailLogo();
  };

  getDownloadLink = () => {
    const { selectedDelivery } = this.props;
    let bulkSampleLink = "";
    switch (selectedDelivery) {
      case 1:
        bulkSampleLink = XOXOLINK_BULK_SAMPLE_ONLY_EMAIL;
        break;
      case 2:
        bulkSampleLink = XOXOLINK_BULK_SAMPLE_ONLY_MESSAGE;
        break;
      case 3:
        bulkSampleLink = XOXOLINK_BULK_SAMPLE_BOTH_EMAIL_MESSAGE;
        break;
      default:
        bulkSampleLink = XOXOLINK_BULK_SAMPLE_BOTH_EMAIL_MESSAGE;
        break;
    }
    return bulkSampleLink;
  };

  handleUrl = (fileUrl = "") => {
    const { uploadFileData } = this.props;
    if (!fileUrl) {
      fileUrl = BULK_UPLOAD_SAMPLE_FILE_DATA[uploadFileData.reward_type - 1];
    }
    if (this.props.reward_type === 3) {
      fileUrl = this.getDownloadLink();
      window.open(fileUrl);
      return;
    }
    const downloadData = {
      query: "stores.mutation.fileDownload",
      tag: "stores",
      variables: {
        add_data: fileUrl,
      },
    };
    makeRequestAuth(
      downloadData,
      function (resp) {
        if (
          resp &&
          resp.data &&
          resp.data.fileDownload &&
          resp.data.fileDownload.output
        ) {
          let response = JSON.parse(resp.data.fileDownload.output);
          let url = "data:" + response.type + ";base64," + response.data;
          var link = document.createElement("a");
          link.download = response.filename;
          link.href = url;
          link.click();
        }
      }.bind(this)
    );
  };

  fetchBulkVouhcers = () => {
    let downloadButton = document.getElementById("download-file-plum-pro");
    if (this.state.voucherProducts.length > 0) {
      downloadButton.click();
      return;
    }
    let filterParams = { store_id: 4 };
    this.setState({ bulkProductsLoading: true });
    try {
      const voucherPostData = {
        query: "voucher.mutation.bulk_voucher_list",
        tag: "voucher",
        variables: {
          voucherParams: JSON.stringify(filterParams),
        },
      };
      makeRequestAuth(
        voucherPostData,
        (response) => {
          this.setState({ bulkProductsLoading: false });
          if (
            response.data &&
            response.data.fetchVouchers &&
            response.data.fetchVouchers.Error == false &&
            response.data.fetchVouchers.count
          ) {
            this.setState({ bulkProductsLoading: false });
            response = response.data.fetchVouchers;
            if (response.products && Array.isArray(response.products)) {
              this.setState({ voucherProducts: response?.products }, () => {
                downloadButton.click();
              });
            }
          } else {
            NotificationManager.error("Something went wrong");
          }
        }, //Callback
        {}, //Header
        "" //url
      );
    } catch (e) {
      this.setState({ bulkProductsLoading: false });
      NotificationManager.error("Something went wrong");
      /* empty */
    }
  };

  /* 
        ==================================================================================
        ==================================================================================
        Bulk Process
        ==================================================================================
        ==================================================================================
    */
  fetchActivationSteps = () => {
    this.setState({
      loading: true,
    });
    ProfileService.getActivationSteps()
      .then((response) => {
        if (response) {
          this.setState({
            loading: false,
          });
          this.props.history.push(`/${app_path}/dashboard`);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  uploadAgain = (isFromDiy = 0, reopenfileupload) => {
    const startdate = moment();
    const new_date = moment(startdate, "DD-MM-YYYY").add(365, "days");
    this.props.setUploadFileData(DEFAULT_BULK_UPLOAD_DATA);
    this.props.setIsFileUploaded(false);
    this.props.setBulkSuccess(false);
    this.props.setDisabled(true);
    this.props.handleReset();
    this.setState(
      {
        templateModal: false,
        removeFile: false,
        subHeader: "", // sub header of success modal
        preview: false,
        activeTab: "1",
        addAmount: 0,
        confirmSendModal: false,
        actionModalMessage: "",
        confirmSendBtnText: "Send",
        showPaymentModal: false,
        showmessageModal: false, // state to manage sucess message
        successMessage: "", // stores success message
        smsLink: this.state.smsLink,
        activePreviewTab: "1",

        // bulk related state
        isBulkUpload: false, //bulk upload switch
        selectedDate: new_date.format("DD-MM-YYYY"),
      },
      () => {
        this.props.resetBulkUploadData();
        if (reopenfileupload === "reopenfileupload") {
          this.fileInput?.current?.click();
        }
        this.setInitialData();
        if (isFromDiy == 1) {
          this.fetchActivationSteps();
        }
      }
    );
  };

  fileUpload = (event) => {
    const { reward_type } = this.props;
    let { uploadFileData } = this.props;
    uploadFileData["reward_type"] = reward_type;
    uploadFileData.attachments = event.target.files[0];
    var allowedExtensions = /(\.csv|\.xlsx)$/i;
    if (!allowedExtensions.exec(uploadFileData?.attachments?.name)) {
      NotificationManager.error(
        "Invalid file type. Only CSV and XLSX files are allowed."
      );
      return false;
    }
    uploadFileData.skip_filename_check = 0;
    this.props.setIsFileUploaded(true);
    this.props.setDisabled(false);
    this.props.setUploadFileData(uploadFileData);
    this.props.updateFileName(uploadFileData.attachments.name);
    this.props.updateBulkProcessing(1);
    this.props.updateBulkScreenMsg("");
    this.props.updateBulkScreenError("");
  };

  uploadBulkFileData = () => {
    const { uploadFileData } = this.props;
    const {
      selectedSite,
      emailLogo,
      emailHeading,
      emailTitle,
      smsText,
      expiryMonth,
      emailSubject,
      selectedTemplate,
      buttonText,
      whatsappText,
      whatsappAlbumImageId,
      sendMode,
    } = this.props;

    const { reward_type, campaignId, selectedDelivery } = this.props;
    if (!uploadFileData.attachments) {
      NotificationManager.error("Please upload file first", "Error");
      return;
    }
    let mail_details = {};
    let sms_details = {};
    let whatsapp_details = {};
    mail_details = {
      album_img_id: selectedTemplate.image_id,
      logo: emailLogo && emailLogo.length > 250 ? "" : emailLogo,
      heading: emailTitle,
      subject: emailSubject,
      message: emailHeading,
      redeem_button_text: buttonText,
    };
    sms_details = {
      text: smsText,
    };
    whatsapp_details = {
      text: whatsappText,
      album_img_id: `${whatsappAlbumImageId}`,
    };
    let params = {
      mail_details: mail_details,
      sms_details: sms_details,
      campaign_id:
        reward_type == 3
          ? campaignId
            ? campaignId
            : 0
          : selectedSite?.id
          ? selectedSite.id
          : 0,
      ...uploadFileData,
      mode_of_communication: sendMode?.join(","),
    };
    params.setBulkUploadError = this.props?.setBulkUploadError;

    if (sendMode?.includes("whatsapp")) {
      params["whatsapp_details"] = whatsapp_details;
    }

    if (
      reward_type === REWARD_TYPES.XOXO_CODE ||
      reward_type === REWARD_TYPES.XOXO_LINK
    ) {
      params.expiry_month = expiryMonth?.value;
      if (expiryMonth?.label === "custom") {
        params.expiry_type = expiryMonth?.label;
      } else {
        params.expiry_type = "";
      }
    }
    if (reward_type == 3) {
      params.delivery_method = 3;
    }
    if (this.props?.authentication_type) {
      params.authentication_type = this.props.authentication_type;
    }
    // if (punchout_client_ids?.includes(this.props.accountReducer?.clientId)) {
    //   params.isCxml = true;
    // }
    this.props.uploadFileDataV1(params);
  };

  startBulkProcess = () => {
    const {
      bulkProcessData = [],
      bulkUploadData: {
        batchId = "",
        fileName = "",
        batchProcessData: { currentAmount = 0 },
      },
      reward_type,
    } = this.props;
    const batch_id = sessionStorage.getItem("batch_id");
    let params = {
      reward_type: reward_type,
      batch_id: batchId || batch_id,
    };
    if (reward_type == 3) {
      params.totalAmountInBase = currentAmount;
    }
    this.props.startBulkProcess(
      params,
      bulkProcessData,
      fileName,
      this.uploadAgain
    );
  };

  handleSkipModal = () => {
    const { setActiveTab } = this.props;
    setActiveTab(0);
    this.props.resetBulkUploadData();
    this.props.setDisabled(true);
    this.props.setUploadFileData(DEFAULT_BULK_UPLOAD_DATA);
    this.props.setIsFileUploaded(false);
  };

  handleSkipFileUpload = () => {
    let { uploadFileData = {} } = this.props;
    this.props.updateSkipFileCheck(false);
    uploadFileData.skip_filename_check = 1;
    this.props.setUploadFileData(uploadFileData);
    this.props.updateFileName(uploadFileData.attachments.name);
    this.props.updateBulkProcessing(1);
    this.props.updateBulkScreenMsg("");
    this.props.updateBulkScreenError("");
    this.uploadBulkFileData();
  };

  handleBulkSend = () => {
    const {
      bulkUploadData: {
        batchId = "",
        batchProcessData: {
          currentCount = 0,
          scheduledCount = 0,
          total_rows = 0,
        } = {},
      } = {},
      reward_type,
    } = this.props;
    this.hideFileWarning();
    const sendBtnText = ["Reward Point", "Reward Codes", "Reward Link", ""];
    if (batchId) {
      let actionModalMessage = "";
      const isProcurementApprovalRequired =
        this.props.accountReducer?.platformSettings
          ?.isProcurementApprovalRequired;
      const initialText = isProcurementApprovalRequired
        ? "You are procuring "
        : "You are sending ";
      if (scheduledCount > 0 && currentCount > 0) {
        actionModalMessage =
          initialText +
          sendBtnText[reward_type - 1] +
          " to " +
          currentCount +
          (currentCount > 1 ? " recipients " : " recipient ") +
          "and schedule for " +
          scheduledCount +
          (scheduledCount > 1 ? " recipients" : " recipient") +
          " through CSV file upload. Do you want to proceed?";
      } else if (currentCount > 0 && scheduledCount <= 0 && reward_type !== 4) {
        actionModalMessage =
          initialText +
          sendBtnText[reward_type - 1] +
          " to " +
          currentCount +
          (currentCount > 1 ? " recipients " : " recipient ") +
          "through CSV file upload. Do you want to proceed? ";
      } else if (currentCount <= 0 && scheduledCount > 0) {
        actionModalMessage =
          "You are scheduling " +
          sendBtnText[reward_type - 1] +
          " for " +
          +scheduledCount +
          (scheduledCount > 1 ? " recipients" : " recipient") +
          " through CSV file upload. Do you want to proceed?";
      } else if (reward_type == 3) {
        actionModalMessage =
          initialText +
          "" +
          sendBtnText[reward_type - 1] +
          "" +
          " to " +
          "" +
          total_rows +
          (total_rows > 1 ? " recipients" : " recipient") +
          "" +
          " through CSV file upload. The links sent will be redeemable only by the recipients mentioned. Do you want to proceed?";
      } else if (currentCount > 0 && scheduledCount <= 0 && reward_type === 4) {
        actionModalMessage =
          "Are you sure you want to send Brand " +
          (currentCount > 1 ? "Vouchers" : "Voucher") +
          " to " +
          currentCount +
          (currentCount > 1 ? " recipients" : " recipient") +
          " through CSV file upload. Do you want to proceed? ";
      } else {
        actionModalMessage =
          initialText +
          sendBtnText[reward_type - 1] +
          " to " +
          (scheduledCount + currentCount) +
          (scheduledCount + currentCount > 1 ? " recipients" : " recipient") +
          " through CSV file upload. Do you want to proceed?";
      }

      this.setState({ confirmSendModal: true, actionModalMessage });
    } else {
      this.uploadBulkFileData();
    }
  };

  handleBulkSucces = () => {
    const {
      accountReducer: { userBalance: { currencyCode = "INR" } = {} } = {},
      bulkUploadData: {
        batchProcessData: {
          total_rows = 0,
          currentAmount = 0,
          scheduledCount = 0,
          currentCount = 0,
          scheduledAmount = 0,
        },
      } = {},
      reward_type,
    } = this.props;
    const sendBtnText = [
      "Reward Points ",
      "Reward Codes ",
      "Reward Link",
      "Gift Cards",
    ];
    let showmessageModal = true;
    let successMessage = `Rewards are Processing!`;
    let subHeading = "";

    if (scheduledCount > 0 && currentCount > 0) {
      subHeading =
        "You have successfully sent " +
        sendBtnText[reward_type - 1] +
        " for " +
        currentCount +
        (currentCount > 1 ? " recipients" : " recipient") +
        " and scheduling for " +
        scheduledCount +
        (scheduledCount > 1 ? " recipients" : " recipient") +
        " worth " +
        currencyCode +
        " " +
        (scheduledAmount + currentAmount) +
        ". These rewards may take few minutes to process.";
    } else if (currentCount > 0 && scheduledCount <= 0) {
      subHeading =
        "You have successfully sent " +
        sendBtnText[reward_type - 1] +
        " to " +
        currentCount +
        (currentCount > 1 ? " recipients" : " recipient") +
        " worth " +
        currencyCode +
        " " +
        (scheduledAmount + currentAmount);
      (". These rewards may take few minutes to process.");
    } else if (currentCount <= 0 && scheduledCount > 0) {
      successMessage = "Rewards Scheduled Successfully!";
      subHeading =
        "You have successfully sent " +
        sendBtnText[reward_type - 1] +
        " to " +
        +scheduledCount +
        (scheduledCount > 1 ? " recipients" : " recipient") +
        " worth " +
        currencyCode +
        " " +
        (scheduledAmount + currentAmount);
    } else {
      subHeading =
        "You have successfully sent " +
        sendBtnText[reward_type - 1] +
        " to " +
        total_rows +
        (total_rows > 1 ? " recipients" : " recipient") +
        " worth " +
        currencyCode +
        " " +
        (scheduledAmount + currentAmount);
    }
    if (this.props.distributionType === 0 && this.props.reward_type === 3) {
      subHeading =
        "You have successfully sent " +
        sendBtnText[reward_type - 1] +
        " to " +
        total_rows +
        (total_rows > 1 ? " recipients" : " recipient");
    }
    let subHeaderComponent = (
      <>
        <Typography component="div" className="mb-0">
          {subHeading}
        </Typography>
        <br />
        <Typography>
          You can view details for this rewarding instance under Reports.
        </Typography>
      </>
    );
    getUserBalance(this.props.updateUserBalancekProcess);
    this.setState({
      isLoading: false,
      showmessageModal,
      successMessage: successMessage,
      subHeader: subHeaderComponent,
    });
  };

  /* 
        ==================================================================================
        ==================================================================================
        Toggle Function
        ==================================================================================
        ==================================================================================
    */

  toggle = () => {
    this.setState({
      templateModal: !this.state.templateModal,
    });
  };

  toggleRemoveFile = () => {
    this.setState({
      removeFile: !this.state.removeFile,
    });
  };

  toggleConfirmSendModal = () => {
    this.setState({
      confirmSendModal: !this.state.confirmSendModal,
    });
  };

  showFileWarning = () => {
    this.setState({ fileEditWarning: true });
  };

  hideFileWarning = () => {
    this.setState({ fileEditWarning: false });
  };

  /* 
        ==================================================================================
        ==================================================================================
        Paymnet Related Function
        ==================================================================================
        ==================================================================================
    */

  handleAmountChange = (event) => {
    if (event && event.target) {
      let amount = event.target.value;
      var reg = /^\d+$/;
      if (
        !(amount.length == 0 && amount == "") &&
        (!reg.test(amount) || parseInt(amount) == 0)
      ) {
        return;
      }
      this.setState({
        addFundError: "",
        addAmount: parseInt(amount) ? parseInt(amount) : "",
      });
    }
  };

  sendToReports = () => {
    const {
      accountReducer: {
        typeData: { walletCompany = 0 },
      },
      reward_type,
    } = this.props;

    let redirectLink = walletCompany
      ? `/${app_path}/reports/xoxo-token-report`
      : `/${app_path}/reports/voucher-recharge`;
    let activeTab = 1;
    let title = "";
    switch (reward_type) {
      case REWARD_TYPES.XOXO_CODE:
        activeTab = "3";
        title = "reward-code";
        break;
      case REWARD_TYPES.XOXO_POINTS:
        activeTab = "2";
        title = "reward-points";
        break;
      case REWARD_TYPES.XOXO_LINK:
        activeTab = "6";
        title = "reward-link";
        break;
      case REWARD_TYPES.PLUM_PRO:
        activeTab = walletCompany ? "7" : "2";
        redirectLink = walletCompany
          ? `/${app_path}/reports/xoxo-token-report`
          : `/${app_path}/reports/plum-pro-report`;
        title = "gift-card";
        break;
      default:
        break;
    }
    this.props.history.push({
      pathname: redirectLink,
      activeTab: activeTab,
      title: title,
    });
  };
  updateXoxolinkPreview = () => {
    this.setState({
      emailSubject: this.props.emailSubject,
      emailHeading: this.props.emailHeading,
      emailTitle: this.props.emailTitle,
      emailLogo: this.props.company_primary_logo,
      selectedTemplate: this.props.selectedTemplate,
      buttonText: this.props.buttonText,
      smsLink: this.props.smsLink,
      smsText: this.props.smsText,
      smsTextCount: this.props.smsTextCount,
    });
  };
  /* 
        ==================================================================================
        ==================================================================================
        Render Related Function
        ==================================================================================
        ==================================================================================
    */

  checkForLowBalance = () => {
    const {
      accountReducer: {
        userBalance: { userBalance = 0 } = {},
        typeData: { walletCompany = 0 } = {},
        plumProPoints: { balance = 0 } = {},
        distributionType = 0,
      } = {},
      reward_type,
    } = this.props;
    let isLowBalance = false;
    if (walletCompany === 0) {
      isLowBalance =
        reward_type === 4 ? parseFloat(balance) === 0 : userBalance === 0;
    } else if (walletCompany === 1) {
      isLowBalance =
        userBalance === 0 && !(reward_type === 3 && distributionType === 0);
    }
    return isLowBalance;
  };

  renderActveScreen = (disableSend, disableBulkUpload) => {
    const {
      accountReducer: {
        userBalance: { currencyCode = "INR" } = {},
        kybStatus = {},
      } = {},
      bulkUploadData: {
        uploadFileMsg = "",
        fileName = "",
        uploading = false,
        activeScreen = 0,
        batchProcessData: { total_rows = 0, currentAmount = 0 },
        uploadFileErr = "",
      } = {},
      reward_type,
      toggleBulkProcess,
      toggleGenerateForSelf,
    } = this.props;
    const isProcurementApprovalRequired =
      this.props.accountReducer?.platformSettings
        ?.isProcurementApprovalRequired;

    return (
      <>
        {activeScreen === 0 ? (
          <div>
            {/* <div className={`${disableBulkUpload ? "cursor-not-allowed" : ""}`}> */}
            {/* <div
              className={`emptyData w-100 ${
                disableBulkUpload ? "disabled" : ""
              }`}
            > */}
            <div className="emptyData w-100 d-flex flex-column justify-content-center">
              {uploadFileErr != "KYB_NOT_VERIFIED" &&
              uploadFileErr != "PBB10015" &&
              uploadFileMsg != "" ? (
                <div className="w-60 m-auto">
                  <Banner
                    color="error"
                    iconName=""
                    description={uploadFileMsg}
                  />
                </div>
              ) : uploadFileErr == "KYB_NOT_VERIFIED" && uploadFileMsg != "" ? (
                <KybErrorModal
                  closeModal={() => this.setState({ openKybErrorModal: false })}
                  reward_module={
                    reward_type == 1
                      ? "Xoxo Points"
                      : reward_type == 2
                      ? "Xoxo Code"
                      : reward_type == 3
                      ? "Xoxo Link"
                      : "Plum Pro"
                  }
                  kyb_status={kybStatus.kyb_status}
                />
              ) : null}
              {fileName &&
              this.props.isFileUploaded &&
              (uploadFileMsg == "" || uploadFileErr == "PBB10015") ? (
                <div className="w-50 mx-auto d-flex flex-column align-items-center">
                  <Typography.H3 className="mb-8" color="dark" shade="c300">
                    File Uploaded!
                  </Typography.H3>
                  <Typography className="mb-20" color="dark" shade="c200">
                    <>We will verify this file before sending the reward.</>
                  </Typography>
                  <StyledFileDiv>
                    <div className="d-flex align-items-center justify-content-between">
                      <Icon
                        iconName="PlumFile"
                        color="primary"
                        shade="c02"
                        size="20"
                      />
                      <Typography.HelperText
                        className="ml-16"
                        color="dark"
                        shade="c300"
                      >
                        {fileName.length > 25
                          ? fileName.slice(0, 25) + "..."
                          : fileName}
                      </Typography.HelperText>
                    </div>
                    <div className="ml-8">
                      <Button
                        variant="plain"
                        color="primary"
                        onClick={this.toggleRemoveFile}
                      >
                        Remove
                      </Button>
                    </div>
                  </StyledFileDiv>
                </div>
              ) : (
                <div className="mx-auto">
                  <div className="mt-8">
                    <div className="cursor-pointer" id="bulk-click-to-upload">
                      <Label htmlFor="csvuploader" className="mb-0">
                        <Icon
                          iconName="PlumFile"
                          color="primary"
                          shade="c02"
                          className="cursor-pointer p-10"
                          size="l"
                        />
                        <Typography.H3
                          className="cursor-pointer mb-0 mt-8"
                          color="dark"
                          shade="c300"
                        >
                          Click to upload a file
                        </Typography.H3>
                        <Typography.HelperText
                          color="dark"
                          shade="c200"
                          className="mb-0 mt-8"
                        >
                          Support CSV and XLSX files
                        </Typography.HelperText>
                      </Label>
                      <input
                        type="file"
                        id="csvuploader"
                        className="d-none"
                        accept=".csv,.xlsx"
                        ref={this.fileInput}
                        // value={
                        //   !this.props.uploadFileData.attachments
                        //     ? null
                        //     : this.props.uploadFileData.attachments.name
                        // }
                        onChange={(e) => {
                          this.fileUpload(e);
                        }}
                        disabled={this.state.uploading}
                      />
                    </div>
                  </div>
                  <div className="mt-36">
                    <Typography
                      color="dark"
                      shade="c200"
                      className="d-flex justify-content-center align-items-center w-100 text-center m-0 flex-wrap"
                      id="bulk-view-definition-text"
                      component={"span"}
                    >
                      View{" "}
                      <Typography
                        className="m-0 mx-4 cursor-pointer"
                        color="primary"
                        shade="c02"
                        onClick={() => this.toggle()}
                        component={"span"}
                      >
                        Instructions
                      </Typography>{" "}
                      or download
                      {reward_type == 3 ? (
                        <a
                          href={this.getDownloadLink()}
                          className="bulk-csv pl-1"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Typography
                            color="primary"
                            shade="c02"
                            className="m-0 mx-4 cursor-pointer"
                            component={"span"}
                          >
                            CSV template
                          </Typography>
                        </a>
                      ) : (
                        <>
                          <span
                            onClick={() => {
                              if (reward_type === 4) this.fetchBulkVouhcers();
                              else this.handleUrl();
                            }}
                          >
                            <Typography
                              color="primary"
                              shade="c02"
                              className="m-0 mx-4 cursor-pointer"
                            >
                              CSV template
                            </Typography>
                          </span>
                          {reward_type == 4 ? (
                            <DownloadSampleProduct
                              voucherProducts={
                                this.state.voucherProducts
                                  ? this.state.voucherProducts
                                  : []
                              }
                            />
                          ) : null}
                        </>
                      )}
                      to ensure the columns are correct.
                    </Typography>
                    <div className="d-flex justify-content-center mt-8">
                      {this.state.bulkProductsLoading ? (
                        <CircularLoader />
                      ) : null}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : activeScreen === 1 ? (
          <ScanError
            toggleRemoveFile={this.toggleRemoveFile}
            uploadAgain={this.uploadAgain}
            total_rows={total_rows}
            currentAmount={currentAmount}
            currencyCode={currencyCode}
          />
        ) : null}
      </>
    );
  };

  render() {
    const {
      templateModal,
      removeFile,
      actionModalMessage,
      showmessageModal,
      successMessage,
      subHeader,
    } = this.state;

    const {
      accountReducer: {
        userBalance: { userBalance = 0, currencyCode = "INR" } = {},
        typeData: { walletCompany = 0 } = {},
        plumProPoints: { balance = 0 } = {},
        distributionType = 0,
        kybStatus = {},
      } = {},
      bulkUploadData: {
        processing = 0,
        uploading = false,
        skipFileCheck = false,
        fileName = "",
        batchProcessData: {
          currentAmount = 0,
          total_rows = 0,
          insufficient_fund = 0,
          insufficient_threshold = 0,
          final_file_path = null,
          status,
        },
        uploadFileErr = "",
      },
      reward_type,
      selectedDelivery = 1,
      denomination_val,
      blockSendingRewards = false,
      handlingCharge = 0,
      baseCurrencyConversionValue = 0,
    } = this.props;

    let rewardType = [
      "Reward Points",
      "Reward Code",
      "Reward Link",
      "Gift Cards",
    ];

    const isProcurementApprovalRequired =
      this.props.accountReducer?.platformSettings
        ?.isProcurementApprovalRequired;

    // let disableSend =  (bulkUploading || showBulkPayment) ? true : false ;
    // const previewType = sendSmsSwitch ? "Email/SMS" : "Email";
    const disableSend = uploading || [0, 3, 4].includes(processing);
    const skipModalText = `Are you sure?`;
    const skipFileBody = `File named ${fileName} is already being processed for ${
      rewardType[reward_type - 1]
    }. Make sure you are not uploading the same file. Do you want to continue uploading?`;

    let requiredFund = userBalance;
    requiredFund =
      reward_type == REWARD_TYPES.PLUM_PRO
        ? walletCompany
          ? (requiredFund = userBalance)
          : (requiredFund = balance)
        : requiredFund;

    const disableBulkUpload = this.checkForLowBalance();
    const totalHandlingCharge = parseFloat(
      handlingCharge * baseCurrencyConversionValue * total_rows || 0
    ).toFixed(2);
    const failStatus = [
      BATCH_STATUS_POLLING.FAILURE,
      BATCH_STATUS_POLLING.VALIDATION_FAILURE,
      BATCH_STATUS_POLLING.CANCELLED,
    ];
    return (
      <>
        <StyledBorderedDiv>
          {this.renderActveScreen(disableSend, disableBulkUpload)}
          {/* {reward_type == 3 && distributionType === 0 ? null : (
            <>
              {currentAmount ? (
                <div className="d-flex mt-20">
                  {insufficient_fund || insufficient_threshold ? (
                    ""
                  ) : (
                    <div className="d-flex">
                      <Typography className="mb-0" color="dark" shade="c300">
                        Recipients:
                      </Typography>
                      <Typography
                        className="ml-4 mb-0"
                        color="green"
                        shade="c200"
                      >
                        {total_rows}
                      </Typography>
                    </div>
                  )}
                  {insufficient_fund || insufficient_threshold ? (
                    ""
                  ) : (
                    <>
                      <div>
                        <Typography className="mx-12 my-0">|</Typography>
                      </div>
                      <div className="d-flex">
                        <Typography.H3
                          className="mb-0"
                          color="dark"
                          shade="c300"
                        >
                          Grand Total:{" "}
                          {currencyCode +
                            " " +
                            (currentAmount && currentAmount >= 0
                              ? currentAmount
                              : 0
                            )
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                          {totalHandlingCharge &&
                          totalHandlingCharge !== "0.00" ? (
                            <GrandTotalToolTip
                              currencyCode={currencyCode}
                              totalHandlingCharge={totalHandlingCharge}
                              totalInUserCurrency={
                                currentAmount - totalHandlingCharge
                              }
                            />
                          ) : (
                            ""
                          )}
                        </Typography.H3>
                      </div>
                    </>
                  )}
                </div>
              ) : null}
            </>
          )} */}
        </StyledBorderedDiv>
        {reward_type === 4 && (
          <BrandApprovalWarningBanner kybStatus={kybStatus} />
        )}
        {templateModal ? (
          <TemplateGuideModal
            value={BULK_COLUMN_DEF[reward_type - 1]}
            modalStatus={() => {
              this.toggle();
            }}
            title={rewardType[reward_type - 1]}
            handleUrl={this.handleUrl}
            bulkVoucherProducts={this.state.voucherProducts}
            rewardType={this.props.reward_type}
            getDownloadLink={this.getDownloadLink}
            fetchBulkVouhcers={this.fetchBulkVouhcers}
            bulkProductsLoading={this.state.bulkProductsLoading}
          />
        ) : null}

        <Modal isOpen={uploading} size="sm">
          <Icon color="primary" iconName="PlumHourGlass" size="l" shade="c02" />
          <div className="d-flex justify-content-between flex-column mt-12">
            Verifying File...
            <Typography className="mt-12">
              Hold on while we verify and ensure your file is error-free.
            </Typography>
            <Loaders
              variant="determinate"
              bgcolor="primary"
              value={this.state.progress}
            />
          </div>
        </Modal>
        {/* replace file modal */}
        <Modal
          isOpen={removeFile}
          size="sm"
          onClose={() => {
            this.toggleRemoveFile();
          }}
        >
          <div className="d-flex justify-content-between">
            <Typography.H2>Are You Sure?</Typography.H2>
            <Icon
              iconName="Close"
              size="16"
              color="dark"
              shade="c200"
              className="cursor-pointer"
              onClick={() => {
                this.toggleRemoveFile();
              }}
            />
          </div>
          <Typography color="dark" shade="c200" className="mt-12">
            You are about to remove your uploaded file. Do you want to proceed?
          </Typography>
          <div className="d-flex mt-20" style={{ justifyContent: "flex-end" }}>
            <Button
              className="mr-12"
              variant="plain"
              color="primary"
              onClick={() => this.toggleRemoveFile()}
            >
              No, Cancel
            </Button>
            <Button
              color="primary"
              onClick={() => {
                this.uploadAgain(0);
              }}
            >
              Yes, Proceed
            </Button>
          </div>
        </Modal>
        {/* send rewards modal */}
        {/* <Modal
          isOpen={final_file_path === null && status === "VALIDATION_SUCCESS"}
          size="sm"
          onClose={() => {
            this.uploadAgain();
          }}
        >
          <div className="d-flex justify-content-between">
            <Typography.H2>Are You Sure?</Typography.H2>
            <Icon
              iconName="Close"
              size="16"
              color="dark"
              shade="c200"
              className="cursor-pointer"
              onClick={() => {
                this.uploadAgain();
              }}
            />
          </div>
          <Typography color="dark" shade="c200" className="mb-0 mt-12">
            {actionModalMessage}
          </Typography>
          <div className="d-flex mt-32" style={{ justifyContent: "flex-end" }}>
            <Button
              className="mr-12"
              variant="plain"
              color="primary"
              onClick={() => this.uploadAgain()}
            >
              No, Cancel
            </Button>
            <Button
              color="primary"
              onClick={() => {
                this.startBulkProcess();
              }}
            >
              Yes, Send
            </Button>
          </div>
        </Modal> */}

        <Modal
          isOpen={skipFileCheck && uploadFileErr == "PBB10015"}
          size="sm"
          onClose={() => {
            this.handleSkipModal();
          }}
        >
          <div className="d-flex justify-content-between">
            <Typography.H2>{skipModalText}</Typography.H2>
            <Icon
              iconName="Close"
              size="16"
              color="dark"
              shade="c200"
              className="cursor-pointer"
              onClick={() => {
                this.handleSkipModal();
              }}
            />
          </div>
          <Typography
            style={{ marginTop: "12px", marginBottom: "32px" }}
            color="dark"
            shade="c200"
          >
            {skipFileBody}
          </Typography>
          <div className="d-flex" style={{ justifyContent: "flex-end" }}>
            <Button
              className="mr-12"
              variant="plain"
              color="primary"
              onClick={() => this.handleSkipModal()}
            >
              No, Cancel
            </Button>
            <Button
              color="primary"
              onClick={() => {
                this.handleSkipFileUpload();
              }}
            >
              Continue with verification
            </Button>
          </div>
        </Modal>

        <Modal
          isOpen={showmessageModal}
          size="sm"
          onClose={() => {
            this.uploadAgain(0, false, 1);
            reward_type == 3 ? this.props.restToIntialState() : null;
          }}
        >
          <div>
            <Icon
              color="success"
              iconName="PlumCheckbox"
              size="xl"
              shade="c04"
            />
            <Typography.H2>{successMessage}</Typography.H2>
          </div>
          <Typography
            style={{ marginTop: "12px", marginBottom: "32px" }}
            color="dark"
            shade="c200"
          >
            {subHeader}
          </Typography>
          <div className="d-flex mt-20" style={{ justifyContent: "flex-end" }}>
            <Button
              className="mr-12"
              variant="plain"
              color="primary"
              onClick={() => {
                this.sendToReports();
                this.props.handleReset();
                this.props.setBulkSuccess(true);
              }}
            >
              View Reports
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                this.uploadAgain(0, false, 1);
                this.props.handleReset();
                this.props.setBulkSuccess(true);
              }}
            >
              OK, Got It
            </Button>
          </div>
        </Modal>
        <Modal
          isOpen={
            !this.props.total_validation_error &&
            !failStatus.includes(this.props.status) &&
            this.props.bulkUploadData?.cxmlData
          }
          size="sm"
          style={{ width: "778px", height: "443px" }}
          onClose={() => {
            this.uploadAgain();
          }}
          className="p-36"
        >
          <div className="d-flex justify-content-between">
            <Typography.H2>
              <XoxodayLongLogo width="auto" height="35" />
            </Typography.H2>
            <Typography.H2>
              <img src="/admin/img/workday.png" height="35" />
            </Typography.H2>
          </div>
          <StyledBorderHorizontal className="mt-20" />
          <div className="d-flex justify-content-center mt-28">
            <Icon
              color="success"
              iconName="PlumCheckbox"
              onClick={() => {}}
              padding="2px"
              shade="c03"
              size="l"
            />
          </div>
          <Typography.H2
            color="dark"
            shade="c300"
            className="mb-0 mt-20  text-center"
          >
            Sending Claim Code to your procurement system...
          </Typography.H2>
          <Typography
            component="div"
            color="dark"
            shade="c200"
            className="mb-0 mt-20  text-center"
          >
            You are being redirected to your e-procurement system. Your claim
            codes will be delivered to recipients after we receive an approval
            from your e-procurement system.
          </Typography>
          <div className="mt-20 text-center">
            <Typography.BodySmall color="dark" shade="c200">
              Need help? Please contact{" "}
              <Typography
                component="a"
                href="https://www.xoxoday.com/company/contact-us"
                color="primary"
                shade="c03"
              >
                cs@giift.com
              </Typography>{" "}
            </Typography.BodySmall>
          </div>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    accountReducer,
    bulkProcessReducer: {
      bulkUploadData: {
        uploadFileMsg = "",
        uploading = false,
        fileName = "",
        activeScreen = 0,
      } = {},
    } = {},
  } = state;
  return {
    accountReducer,
    uploadFileMsg,
    uploading,
    fileName,
    activeScreen,
    bulkUploadData: state.bulkProcessReducer.bulkUploadData,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      uploadFileDataV1: (params) => uploadFileDataV1(params),
      updateBulkUploadFileUploader: (param) =>
      updateBulkUploadFileUploader(param),
      updateBulkUploadFormData: (param) => updateBulkUploadFormData(param),
      updateBulkScreen: (param) => updateBulkScreen(param),
      updateFileName: (param) => updateFileName(param),
      resetBulkUploadData: () => resetBulkUploadData(),
      startBulkProcess: (param, bulkProcessData, fileName, uploadAgain) =>
      startBulkProcess(param, bulkProcessData, fileName, uploadAgain),
      updateBulkProcessing: (params) => updateBulkProcessing(params),
      updateBulkScreenMsg: (params) => updateBulkScreenMsg(params),
      updateBulkScreenError: (params) => updateBulkScreenError(params),
      updateSkipFileCheck: (params) => updateSkipFileCheck(params),
      updateUserBalance: (params) => updateUserBalance(params),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(BulkProcess);
